import React from "react";
import apiUrl from "../../apiUrlConstant";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie, Doughnut } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import { piexceldataFormate } from "../../utils/utils";
import Dropdown from "react-bootstrap/Dropdown";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { JsonToExcel } from "react-json-to-excel";
import { Loader } from 'rsuite';  
import domtoimage from 'dom-to-image';
ChartJS.register(ArcElement, Tooltip, Legend);
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class TransactionSizeWiseShare extends React.Component {
  state = {
    inventoryByCity: {},
    xAxis: [],
    barThicknesS: 10,
    chartOtions: {},
    chartData: {
      labels: [],
      datasets: [],
    },
    showPie: false,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const superClass = this;

    fetch(
      `${apiUrl.apiUrl.url}/dashboard/txn-wise-share?search=` +
        this.props.searchTerm +
        `&assetVal=${this.props.assetVal}&leaseStatus=${this.props.leaseStatus}&occupierVal=${this.props.occupierVal}`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "datata 34 ");
        this.setState({ inventoryByCity: data });
        const convertedData = piexceldataFormate(
          data,
          "Assets",
          "Total Area (sqft)"
        );
        const data1 = {
          labels: data.x, /// ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
          datasets: [
            {
              label: "# of Votes",
              data: data.datapoints.y1, // [12, 19, 3, 5, 2, 3],
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(54, 162, 235, 0.2)",
                "rgba(255, 206, 86, 0.2)",
                "rgba(75, 192, 192, 0.2)",
                "rgba(153, 102, 255, 0.2)",
                "rgba(255, 159, 64, 0.2)",
              ],
              borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderWidth: 1,
            },
          ],
        };
        superClass.setState({
          chartData: data1,
          showPie: true,
          convertedData: convertedData,
        });
      });
  }

  downloadPdf = () => {
    const input = document.getElementById("transactionWiseShare");
    domtoimage.toPng(input).then((canvas) => {
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(canvas);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(canvas, "JPEG", 0, 0, pdfWidth, pdfHight);
      pdf.save("transactionWiseShare.pdf");
    });
  };

  render() {
    return (
      <>
        <div className="row m-0">
          <div className="col-lg-6 p-0">
            <h4>Transaction Size wise Share</h4>
          </div>
          <div className="col-lg-12 p-0 position-relative float-right">
            <Dropdown style={{ float: "right" }}>
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                className="chartDownloadContainer"
              ></Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={(e) => {
                    this.downloadPdf();
                  }}
                >
                  Download as PDF
                </Dropdown.Item>
                <Dropdown.Item>
                  <JsonToExcel
                    title="Download as Excel"
                    data={this.state.convertedData}
                    fileName="transactionWiseShare"
                    btnClassName="graphExcelDownloadBtn"
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="col-12 position-relative" id="transactionWiseShare">
          {
              (this.state.showPie == false) && 
              <Loader size="lg" content="Loading... " center />
            }
            
          {this.state.showPie && <Doughnut data={this.state.chartData} />}
        </div>
      </>
    );
  }
}
export default withRouter(TransactionSizeWiseShare);
